import React from "react";
import './Form.scss';
import { IFormType, IOperationData, MatchExpr, ICardToListOptionType } from "../constants/types";
import { WithTranslation, withTranslation } from "react-i18next";
import { municipalityOrCompany, insuranceChoice } from '../data/apiconnect'
import Form from './Form';
import ErrorPage from "../components/pages/errorPage/ErrorPage";

interface Props extends WithTranslation {
    form: IFormType
};

interface State {
    form: IFormType | null
    loading: boolean
    errorOccured: boolean
};

class InitForm extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            form: null,
            loading: true,
            errorOccured: false
        }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.setState({ errorOccured: true })
    }

    async componentDidMount() {
        let { form } = this.props;

        let [municipalityOrCompanyData, insuranceChoiceData] = await Promise.all([municipalityOrCompany(this.onError), insuranceChoice(this.onError)])

        Object.keys(form.pages).forEach((index: any) => {
            if (form.pages[index].id == "municipalityOrCompany") {
                //@ts-ignore
                form.pages[index].operation.suggestions = (municipalityOrCompanyData || []).map(e => (
                    { text: e.name, key: e.key }
                ))
            }
            if (form.pages[index].id == "insuranceChoice") {
                //@ts-ignore
                form.pages[index].operation.suggestions = (insuranceChoiceData || []).map(e => (
                    { text: e.name, key: e.key }
                ))
            }
        });
        this.setState({ form, loading: false });
    }

    onError = (error: any) => {
        console.error(error)
        this.setState({ errorOccured: true })
    }

    render(): React.ReactNode {
        let { form, loading, errorOccured } = this.state;
        return (
            <>
                {!loading && !errorOccured && <Form form={this.state.form as IFormType} />}
                {errorOccured && < ErrorPage message="general.error-information-text" />}
            </>
        )
    }
}

export default withTranslation()(InitForm);
